<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 55px;"></div>
		<designer />
		<div class="home">
			<div @click="go('My')">我的主页</div>
			<div> < </div>
					<div style="color: #E66617;">我的推广</div>
			</div>
			<div class="wrapList">
				<div class="wrap-tab">
					<div class="wrap-tab-item" :class="activeIndex==1?'active':''" @click="handleSelect(1)">下线推广</div>
					<div class="wrap-tab-item" :class="activeIndex==2?'active':''" @click="handleSelect(2)">我的下线</div>
					<div class="wrap-tab-item" :class="activeIndex==3?'active':''" @click="handleSelect(3)">我的收益</div>
				</div>
				<div>
					<div class="off" v-if="activeIndex==1">
						<div class="offline">
							<div style="font-weight: 600;">下线推广</div>
							<div class="reward">
								<div v-for="(item,index) in content">{{index+1}}. {{ item }}</div>
							</div>
							<div class="promotelinks"> 您的推广链接 </div>
							<div
								style="background-color: RGBA(240, 242, 244, 1);padding: 9px 13px;display: flex;justify-content: space-between;align-items: center;margin-top: 13px;">
								<div style="color: rgba(136, 136, 136, 1);font-size: 12px;">
									{{ message }}
								</div>
								<div style="color: rgba(230, 102, 23, 1);" v-clipboard:copy="message"
									v-clipboard:success="onCopy">复制</div>
							</div>
							<div style="margin-top: 19px;">
								<div style="border: 1rpx red solid;" id="qrcode" ref="qrcode"></div>
							</div>
						</div>
					</div>
					<div v-if="activeIndex==2">
						<el-select v-model="type" placeholder="推广级别"
							style="width:40%;padding-top: 10px;padding-bottom: 10px;" @change="getMyReferrals">
							<el-option label="全部" value=""></el-option>
							<el-option label="一级分销" value="1"></el-option>
							<el-option label="二级分销" value="2"></el-option>
						</el-select>
						<el-table :data="tableData" style="width: 100%">
							<el-table-column prop="users_id" label="ID" align="center">
							</el-table-column>
							<el-table-column prop="nickname" label="昵称" align="center">
							</el-table-column>
							<el-table-column prop="archives_count" label="作品数量" align="center" width="50">
							</el-table-column>
							<el-table-column prop="parent_count" label="推广人数" align="center" width="50">
							</el-table-column>
							<el-table-column prop="order_count" label="订单数" align="center" width="50">
							</el-table-column>
							<el-table-column prop="parent_level_name" label="推广级别" align="center">
							</el-table-column>
							<el-table-column prop="reg_time" label="注册时间" align="center">
							</el-table-column>
						</el-table>
						<div class="page-box">
							<div class="pages">
								<el-pagination @current-change="handleCurrentChange" :page-size="size"
									layout="total, prev, pager, next" :total="count">
								</el-pagination>
							</div>
						</div>
					</div>
					<div v-if="activeIndex==3">
						<div class="top-box">
							<div class="top-item">
								<div class="num">{{ mouth_money || 0 }}</div>
								<div class="text">新款区域当月</div>
							</div>
							<div class="shu"></div>
							<div class="top-item">
								<div class="num">{{ year_money || 0 }}</div>
								<div class="text">新款区域当年</div>
							</div>
							<div class="shu"></div>
							<div class="top-item">
								<div class="num">{{ yc_mouth_money || 0 }}</div>
								<div class="text">原创区域当月</div>
							</div>
							<div class="shu"></div>
							<div class="top-item">
								<div class="num">{{ yc_year_money || 0 }}</div>
								<div class="text">原创区域当年</div>
							</div>
						</div>
						<el-table :data="tableData1" style="width: 100%">
							<el-table-column prop="memo" label="奖励缘由" align="center">
							</el-table-column>
							<el-table-column prop="create_time" label="奖励时间" align="center">
							</el-table-column>
							<el-table-column prop="money" label="推广收益" align="center">
							</el-table-column>
						</el-table>
						<div class="page-box">
							<div class="pages">
								<el-pagination @current-change="handleCurrentChange" :page-size="size"
									layout="total, prev, pager, next" :total="count1">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
			<info />
			<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
			<foot />
		</div>
</template>
<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import designer from "../../components/common/designer.vue";
	import QRCode from "qrcodejs2";
	import {
		extensionMyPromotion
	} from "../../request/api";
	import {
		extensionMyEarnings,
		extensionMyReferrals
	} from "../../../../ytht-pc/src/request/api";
	export default {
		components: {
			top,
			foot,
			designer,
			info
		},
		data() {
			return {
				content: '',
				invitation_code: '',
				localhostPath: '',
				message: '',
				activeIndex: 1,
				tableData: [],
				tableData1: [],
				count: 1,
				count1: 1,
				size: 10,
				page: 1,
				type: '',
				mouth_money: 0,
				year_money: 0,
				yc_mouth_money: 0,
				yc_year_money: 0,
			};
		},
		created() {
			document.title = '以图绘图印花设计网-我的推广';
			let wPath = window.document.location.href;
			let pathName = this.$route.path;
			let pos = wPath.indexOf(pathName);
			this.localhostPath = wPath.substring(0, pos);
			this.getMyPromotion();
			this.getMyReferrals();
			this.getMyEarnings();
		},
		methods: {
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
			},
			//我的推广 - 我的推广
			getMyPromotion() {
				extensionMyPromotion().then((res) => {
					console.log(res);
					this.content = res.data.content
					this.invitation_code = res.data.invitation_code
					this.qrcode();
					this.message = this.localhostPath + "/login?invitation_code=" + this.invitation_code
				});
			},
			qrcode() {
				let aaa = "/login?invitation_code=" + this.invitation_code
				console.log(aaa);
				let qrcode = new QRCode("qrcode", {
					width: 200, // 二维码宽度，单位像素
					height: 200, // 二维码高度，单位像素
					text: this.localhostPath + aaa // 生成二维码的链接
				});
			},
			//我的推广 - 我的下线
			getMyReferrals() {
				extensionMyReferrals({
					page: this.page,
					type: this.type
				}).then((res) => {
					console.log(res)
					this.tableData = res.data.data
					this.count = res.data.total
				});
			},
			// 我的推广 - 我的收益
			getMyEarnings() {
				extensionMyEarnings({
					page: this.page
				}).then((res) => {
					this.tableData1 = res.data.data
					this.count1 = res.data.total
					this.mouth_money = res.data.mouth_money
					this.year_money = res.data.year_money
					this.yc_mouth_money = res.data.yc_mouth_money
					this.yc_year_money = res.data.yc_year_money
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getMyReferrals();
				this.getMyEarnings()
			},
			handleSelect(key) {
				this.activeIndex = key;
				if (key == 1) {
					this.getMyPromotion();
				} else {
					this.page = 1;
					if (key == 2) {
						this.getMyReferrals();
					} else {
						this.getMyEarnings()
					}
					// // this.getDownMealInfo(2);
					// this.getDownMealOrder();
				}
			},
			go(url) {
				this.$router.push({
					name: url,
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	.page {
		background: #F6F6F6;

		.home {
			padding: 0 20px;
			display: flex;
			align-items: center;
			font-size: 13px;

			div {
				margin-right: 7px;
			}
		}

		.off {
			margin-top: 15px;
			padding: 0 10px;

			.offline {
				padding: 18px 12px;
				font-size: 13px;
				background-color: #FFFFFF;
				color: #000000;

				.reward {
					font-size: 12px;
					color: #333333;
					margin-top: 16px;

					div {
						margin-top: 16px;
					}
				}

				.promotelinks {
					margin-top: 40px;
					color: #08243C;
					font-size: 13px;
				}

				img {
					margin-top: 14px;
					width: 150px;
					height: 150px;
				}
			}
		}

		.wrapList {
			margin-top: 15px;
			padding: 0 10px;

			.wrap-tab {
				display: flex;
				background: #fff;
				padding: 0 12px;
				border-bottom: solid 1px #e6e6e6;

				.wrap-tab-item {
					padding: 18px 0;
					margin-right: 10px;
				}

				.wrap-tab-item.active {
					color: rgb(230, 102, 23);
					border-bottom: 2px solid rgb(230, 102, 23);
				}
			}

			.top {
				background: #ffffff;
				font-size: 15px;
				padding: 0 12px;
				line-height: 30px;
			}
		}
	}
	
	.top-box{
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		background-color: #ffffff;
		padding-bottom: 10px;
		
		.top-item{
			width: calc(50% - 1px);
			text-align: center;
			justify-content: space-between;
			margin-top: 15px;
			
			.num {
				    font-size: 20px;
				    font-weight: bold;
			}
			
			.text{
				color: #909399;
			}
		}
	}
</style>